import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent, sendScreenEvent } from 'services/analytics';

// https://data-portal.internal.atlassian.com/analytics/registry/71742
const trackCertificationCardClick = (
  certificationName: string,
  isMainPanel: boolean,
  isPersonalView: boolean,
) => {
  sendUIEvent({
    source: isMainPanel ? SCREEN_NAME.PROFILE : SCREEN_NAME.CERTIFICATIONS,
    action: 'clicked',
    actionSubject: 'card',
    actionSubjectId: 'certificationCard',
    attributes: {
      certificationName: certificationName ?? 'not-named',
    },
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71733
const trackCertificationsScreenView = (isPersonalView: boolean) => {
  sendScreenEvent({
    screenName: SCREEN_NAME.CERTIFICATIONS,
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71746
const trackBackToProfileClick = (isPersonalView: boolean) => {
  sendUIEvent({
    source: SCREEN_NAME.CERTIFICATIONS,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'backToProfile',
    isPersonalView,
  });
};

const trackViewAllCertificationsClick = (isPersonalView: boolean) => {
  sendUIEvent({
    source: SCREEN_NAME.PROFILE,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'viewAllCertifications',
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71738
const trackCertificationsGetStartedClick = (isPersonalView: boolean) => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'certsGetStarted',
    source: SCREEN_NAME.PROFILE,
    isPersonalView,
  });
};

export {
  trackCertificationCardClick,
  trackCertificationsScreenView,
  trackBackToProfileClick,
  trackViewAllCertificationsClick,
  trackCertificationsGetStartedClick,
};
